import { HomePage } from "./../home/home";
import { PlazaSelectPlanInvestPage } from "./../plaza-select-plan-invest/plaza-select-plan-invest";
import { PlazaSelectPlanRentPage } from "./../plaza-select-plan-rent/plaza-select-plan-rent";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-plaza-select-plan-choose",
  templateUrl: "plaza-select-plan-choose.html",
})
export class PlazaSelectPlanChoosePage {
  space: any;
  theme = 1;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {
    this.space = this.navParams.data.space;
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad PlazaSelectPlanChoosePage');
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
  rentPage() {
    this.navCtrl.push(PlazaSelectPlanRentPage, { space: this.space });
  }
  investSocial() {
    this.navCtrl.push(PlazaSelectPlanInvestPage, { space: this.space });
  }
  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-plan-choose/plaza-select-plan-choose.ts